import Backbone from 'backbone';

import Channel from '../utils/channel';

import { hashify } from '../utils/arrays';

const Router = Backbone.Router.extend( {

    initialize(options = {}) {
        Backbone.Router.prototype.initialize.call( this, options );

        this.channel_ = new Channel( writeFn => this.writeFn_ = writeFn );
    },

    execute(callback, args, name) {
        const filteredArgs = [...args];
        // got null in the end. why?
        filteredArgs.pop();

        if (callback)
            this.channel_.write_( [callback, filteredArgs] );
    },

    getChannel() {
        return this.channel_;
    },

}, {

    from(definition) {
        // filter route/event names
        // (event name starts from ":")
        const routeNames = Object.keys( definition )
            .filter( name => !name.startsWith( ':' ) );
        const eventNames = Object.keys( definition )
            .filter( name => name.startsWith( ':' ) )
            .map( name => name.substring( 1 ) );
        
        // build route/event hashes
        const routes = hashify( routeNames, name => [name, definition[name]] )
        const events = hashify( eventNames, name => [name, definition[`:${name}`]] )

        const router = new Router( { routes,  } );
        const channel = router.getChannel();
        
        // attach events from definition to router
        Object.keys( events )
            // event name is JSON object with event definition
            .map( eventName => [eventName, events[eventName]] )
            .forEach( ([eventName, callbackFn]) =>
                // when `name` event triggered on router, take its args
                // and pass to router channel with callbackFn defined 
                // for this event.
                router.on( eventName, (...args) => channel.write_( [callbackFn, args] ) ) );

        return router;
    }

} );

export { Router, route, event, };

function route(urlMask) {
    if (urlMask === '')
        return urlMask;

    if (urlMask.endsWith( '(/*appState)' ))
        return urlMask;

    if (urlMask.endsWith( '/*appState' ))
        return urlMask;

    if (urlMask.endsWith( '/' ))
        return `${urlMask}(*appState)`;

    return `${urlMask}(/*appState)`;
} 

function event(name) {
    return `:${name}`;
}


// WEBPACK FOOTER //
// ./src/js/core/router.js